import { ITreeNode } from './node';
import { enumerable } from '../utils/utils';

function* treeIterator(root: any): Generator<any> {
  yield root;
  for (let child of root.children) {
    yield* treeIterator(child);
  }
}

export interface NodeContext<T> {
  registerNode(node: ITreeNode<T>): void;
  unregisterNode(node: ITreeNode<T>): void;
}

export interface ITree<T> {
  nodes: Record<string, ITreeNode<T>>;
  [Symbol.iterator](): void; // not sure how to handle this in TS?
  setRootNode(node: ITreeNode<T>): void;
  getRootNode(): ITreeNode<T> | undefined;
  hasNodeId(id: string): boolean;
  getNodeById(id: string): ITreeNode<T> | undefined;
  registerNode(node: ITreeNode<T>): void;
  unregisterNode(node: ITreeNode<T>): void;
}
export class Tree<T> implements NodeContext<T>, Iterable<number> {
  private root!: ITreeNode<T>;
  @enumerable(false)
  public nodes: Record<string, ITreeNode<T>> = {};

  public [Symbol.iterator] = () => {
    return treeIterator(this.root);
  };

  public setRootNode(node: ITreeNode<T>): void {
    this.root = node;
    this.registerNode(node);
  }

  public getRootNode(): ITreeNode<T> | undefined {
    return this.root;
  }

  public hasNodeId(id: string): boolean {
    return Boolean(this.nodes[id]);
  }

  public getNodeById(id: string): ITreeNode<T> | undefined {
    return this.nodes[id];
  }

  private _registerNode(node: ITreeNode<T>) {
    if (this.nodes[node.id]) {
      throw new Error(`Duplicate node id: ${node.id}`);
    }
    this.nodes[node.id] = node;
    node.setContext(this);
  }

  public registerNode(node: ITreeNode<T>) {
    const descendants = node.getDescendants();
    this._registerNode(node);
    for (const descendant of descendants) {
      this._registerNode(descendant);
    }
  }

  private _unregisterNode(node: ITreeNode<T>) {
    delete this.nodes[node.id];
    node.setContext(undefined);
  }

  public unregisterNode(node: ITreeNode<T>) {
    const descendants = node.getDescendants();
    this._unregisterNode(node);
    for (const descendant of descendants) {
      this._unregisterNode(descendant);
    }
  }
}
